<template>
    <div class="flex flex-col relative sticky bottom-1">
      <!--==========================================-->
      <cart-icon class="sticky "> </cart-icon>
      <basket-items class="flex-1 overflow-y-auto p-5"></basket-items>
      <order-button :disabled="false" class="py-5 text-center "></order-button>
      <!--==========================================-->
    </div>
</template>
<script>
import BasketItems from '@/components/BasketItems.vue'
import OrderButton from '@/components/OrderButton.vue'
import CartIcon from '@/components/CartIcon.vue'
export default {
  components: {
    BasketItems,
    OrderButton,
    CartIcon
  }

}
</script>
